<template>
    <b-container>
        <b-row class="mb-2">
            <b-col class="text-center">
                <h1 v-if="unsubscribe">{{ $t('members.profileEditor.titleMail') }}</h1>
                <h1 v-else>{{ $t('members.profileEditor.title') }}</h1>
                <p v-if="unsubscribe" v-html="$t('members.profileEditor.bodytextMail')"></p>
                <p v-else v-html="$t('members.profileEditor.bodytext')"></p>
            </b-col>
        </b-row>
        <member-editor
            v-if="voyadoId || encrypted"
            :voyado-id="voyadoId"
            :encrypted="encrypted"
            :unsubscribe="unsubscribe"
        />
    </b-container>
</template>
<script>
import Accordion from "@components/Accordion.vue";
import HttpClient from "@services/HttpClient";
import MemberEditor from '@components/Members/MemberEditor.vue';

export default {
    name: 'MainPage',
    components: {
        MemberEditor,
        Accordion,
        HttpClient
    },
    data(){
        return  {
            voyadoId: null,
            encrypted: null,
            messageId: null,
            unsubscribe: false,
        };
    },
    mounted() {
        this.unsubscribe = this.$route.name === 'u.unsubscribe' ?? false;
        this.voyadoId = this.$route.params.shortMemberId ?? '';
        this.encrypted = this.$route.query.eclub ?? null;
        this.messageId = this.$route.query.message ?? null;
    },
};
</script>
<style scoped>
.loading-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0);

    display: flex;
    justify-content: center;
    align-items: center;
    animation: fadeIn 0.3s forwards;
}
</style>
